import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-179" data-mp="21yd8ya0c84tx">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-electric/40 border-l-4 border-l-electric bg-surface p-4 pr-10 text-foreground shadow-glow-strong" aria-live="polite" data-id="element-180" data-mp="1wyh3e6bzs5c9">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-electric" aria-label="Dismiss notice" data-id="element-181" data-mp="1sh7jyqeg7s20">
            <XIcon className="h-4 w-4" data-id="element-182" data-mp="1nfs031o0brl7" />
          </button>
          <div className="flex gap-3" data-id="element-183" data-mp="19pesj0f12ewe">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-184" data-mp="19odh2uu3nqe5" />
            <div data-id="element-185" data-mp="1eges6dfj7b2l">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-electric" data-id="element-186" data-mp="1egwr5htkw3e7">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-muted" data-id="element-187" data-mp="zt1z83nea326">
                Once your purchase is complete you receive the
                <br data-id="element-188" data-mp="qqkghz6y7sjx" />
                <span className="font-bold text-foreground" data-id="element-189" data-mp="qqaknuz82r6b">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-190" data-mp="vpx0mc6fqlit">Instant digital access by email</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}